import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

export default function AuthShell({ title, subtitle, children }: AuthShellProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-heart-3-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">
              Humanity<span className="text-primary-500">59</span>
            </span>
          </Link>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950">
            {title}
          </h1>
          <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-8">
          {children}
        </div>

        <p className="mt-6 text-center text-sm text-foreground-500">
          <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">
            ← Retour au site
          </Link>
        </p>
      </div>
    </div>
  );
}